import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CachedIcon from '@mui/icons-material/Cached';
import {
  getChatsList,
  getContacts,
} from 'src/actions/chatActions';
import TooltipMUI6Container from 'src/components/TooltipMUI6/TooltipMUI6Container';
import PropTypes from 'prop-types';

function ChatRefresh({
  onClearSearch,
  filterOptions = {},
}) {
  const dispatch = useDispatch();

  const {
    isChatsLoading,
    allContactsList: {
      isContactsLoading,
    } = {},
  } = useSelector((state) => state?.chat || {});

  const loading = useMemo(
    () => !!(isChatsLoading || isContactsLoading),
    [isChatsLoading, isContactsLoading]
  );

  const handleClickRefresh = useCallback(() => {
    onClearSearch(); // Clear the search field
    dispatch(getChatsList(
      true,
      '',
      filterOptions
    )); // Reset with empty search, keep current filter
    dispatch(getContacts());
  }, [dispatch, onClearSearch, filterOptions]);

  return (
    <Box
      sx={{

      }}
    >
      <TooltipMUI6Container
        tooltipProps={{
          title: loading ? (
            <>
              Please wait. Connections are loading now.
            </>
          ) : (
            <>
              Please click this button to refresh connections manually
            </>
          ),
        }}
        disabled={false}
      >
        <IconButton
          onClick={handleClickRefresh}
          disabled={loading}
        >
          <CachedIcon />
        </IconButton>
      </TooltipMUI6Container>
    </Box>
  );
}

ChatRefresh.propTypes = {
  onClearSearch: PropTypes.func.isRequired,
  filterOptions: PropTypes.object,
};

export default ChatRefresh;
